//系统路由
const routes = [
	{
		name: "layout",
		path: "/",
		component: () => import(/* webpackChunkName: "layout" */ '@/layout'),
		children: []
	},
	{
		path: "/login",
		component: () => import(/* webpackChunkName: "login" */ '@/pages/login'),
		meta: {
			title: "登录"
		}
	},
	{
		path: '/403',
		name: 'forbidden',
		component: () => import('@/pages/forbidden'),
		meta: { title: '无权限', type: 'router' }
	},
]

export default routes;
